import { useQuery } from 'react-query';
import { CCWorkflowsApi } from '../api/ccWorkflows';
import { fetchAllPages } from '../utils/pagination';

export const useLinkedCCWorkflows = (companyId: number, itemId: number, enabled = true) => {
  return useQuery({
    queryFn: () =>
      fetchAllPages((offset, limit) => CCWorkflowsApi.fetchCCWorkflowsPage(companyId, itemId, { offset, limit })),
    queryKey: ['linked_cc_workflows', companyId],
    refetchOnWindowFocus: false,
    enabled,
  });
};
